
import { supabase } from './client';
import { SUPABASE_ANON_KEY, getFunctionsUrl } from './config';

// Direct function to test edge function connectivity
export const pingEdgeFunction = async () => {
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    
    if (!sessionData.session) {
      throw new Error('No active session found');
    }

    const baseUrl = getFunctionsUrl();
    const apiKey = SUPABASE_ANON_KEY;
    const authHeader = sessionData.session.access_token ? `Bearer ${sessionData.session.access_token}` : undefined;
    
    console.log("Trying direct fetch to edge function ping endpoint");
    const response = await fetch(`${baseUrl}/create-checkout/ping`, {
      method: 'GET',
      headers: {
        'apikey': apiKey,
        'Authorization': authHeader,
        'x-client-info': 'supabase-js-web/2.49.3',
        'x-deno-subhost': 'supabase-edge-functions'
      }
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Edge function direct fetch error:', response.status, errorText);
      throw new Error(`Edge function returned status ${response.status}: ${errorText}`);
    }
    
    const data = await response.json();
    console.log("Direct fetch response:", data);
    
    return { success: true, data, error: null };
  } catch (error) {
    console.error('Error pinging edge function:', error);
    return { success: false, error, data: null };
  }
};
